import { useState } from 'react'
import { Create, ListButton, TopToolbar } from 'react-admin'
import { DocumentForm, documentRelations, ToggleShowButton } from '~/components'

const DocumentCreateActions = ({ data, showPreview, setShowPreview }) => (
  <TopToolbar>
    <ToggleShowButton
      showState={showPreview}
      setShowState={setShowPreview}
      label='resources.documents.pdf_preview'
    />
    <ListButton label='ra.action.back' />
  </TopToolbar>
)

const DocumentCreate = (props) => {
  const [showPreview, setShowPreview] = useState(false)

  return (
    <Create
      title='resources.documents.create'
      actions={<DocumentCreateActions showPreview={showPreview} setShowPreview={setShowPreview} />}
      {...props}
      transform={documentRelations}
      redirect='list'
    >
      <DocumentForm showPreview={showPreview} />
    </Create>
  )
}

export default DocumentCreate
